if($('body').attr('data-music')) {
    var song = new Audio($('body').attr('data-music'));
    song.loop = true;
    song.play();
}